module.exports = __webpack_public_path__ + "media/images/icons/medupp-brain-dark-5384def11d2a0fc2b518b4b90bf287ae.svg";